import { useEffect, useState } from "react";

const parts = (ms: number) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return [
    { n: Math.floor(s / 86400), label: "Days" },
    { n: Math.floor((s % 86400) / 3600), label: "Hours" },
    { n: Math.floor((s % 3600) / 60), label: "Minutes" },
    { n: s % 60, label: "Seconds" },
  ];
};

/** Live countdown to `target` (ISO string). Renders nothing until mounted so the
 *  prerendered HTML never shows a stale count; calls onDone once it hits zero. */
const Countdown = ({ target, onDone }: { target: string; onDone?: () => void }) => {
  const end = Date.parse(target);
  const [now, setNow] = useState<number | null>(null);

  useEffect(() => {
    setNow(Date.now());
    const id = window.setInterval(() => {
      const t = Date.now();
      setNow(t);
      if (t >= end) {
        window.clearInterval(id);
        onDone?.();
      }
    }, 1000);
    return () => window.clearInterval(id);
  }, [end, onDone]);

  if (now === null) return <div className="h-[80px] md:h-[108px]" aria-hidden="true" />;
  return (
    <div className="flex justify-center gap-2 sm:gap-4 md:gap-8" role="timer" aria-live="off">
      {parts(end - now).map((p) => (
        <div key={p.label} className="min-w-[56px] sm:min-w-[68px] md:min-w-[104px]">
          <div className="font-heading text-4xl leading-none text-white tabular-nums md:text-7xl">
            {String(p.n).padStart(2, "0")}
          </div>
          <div className="btn-caps mt-2 text-xs tracking-[0.16em] text-white/80 md:text-sm">
            {p.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
